import { getResource } from "./Services";
import store from "../Store/index";

function getCurrentLang() {
    const state = store.getState();
    const { language } = state.lang;
    return language;
}

export function getTermsAndConditions(onSuccess, onFail) {
    const lang = getCurrentLang();
    const path = `api/User/GetTermsAndConditions?forScarption=true&language=${lang}`;
    getResource(path, onSuccess, onFail);
}